import { graphql } from "../gql";

export default graphql(`
  query GetGameLog($input: OddsMarketTypesInput!) {
    event(input: $input) {
      homeTeam {
        name
        primaryColor
        iconUrl
        numberfireId
        gameLog {
          season
          week
          gameId
          timestamp
          score
          result
          spread
          opponentTeam {
            name
            iconUrl
            abbreviation
            teamSportsbookUrl
          }
          homeTeam
        }
      }
      awayTeam {
        name
        primaryColor
        iconUrl
        numberfireId
        gameLog {
          season
          week
          gameId
          timestamp
          score
          result
          spread
          opponentTeam {
            name
            iconUrl
            abbreviation
            teamSportsbookUrl
          }
          homeTeam
        }
      }
    }
  }
`);
